// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import { listSelector, entitiesSelector } from '../../../selectors/alertSelectors';
import { usersEntitiesSelector } from '../../../selectors/usersSelectors';
import { makeVehicleEntitySelector } from '../../../selectors/vehicleSelectors';
import { makeCarEntityAutoSelector } from '../../../selectors/carSelectors';
import { entitiesSelector as zoneEntitiesSelector } from '../../../selectors/zoneSelectors';
import Alerts from '../Alerts';
import type { Props } from '../Alerts';

const mapStateToProps = (state: State) => {
    const list = listSelector(state);
    const entities = entitiesSelector(state);

    const callsigns = {};
    for(let i = 0, length = list.length; i < length; i += 1) {
        const alertId = list[i];
        const alert = entities[alertId];
        const icao = alert.icao;

        if(callsigns[icao]) {
            continue;
        }

        const carBuffer = makeCarEntityAutoSelector(icao)(state);

        let callsign;
        if(carBuffer && carBuffer[0]) {
            const car = carBuffer[0];

            if(car && car.TargetIdentification) {
                callsign = car.TargetIdentification;
            }
        }

        if(!callsign) {
            const vehicleEntity = makeVehicleEntitySelector(icao)(state);

            if(vehicleEntity && vehicleEntity.callsign) {
                callsign = vehicleEntity.callsign;
            }
        }

        if(callsign) {
            callsigns[icao] = callsign;
        }
    }

    return {
        list,
        entities,
        callsigns,
        userEntities: usersEntitiesSelector(state),
        zoneEntities: zoneEntitiesSelector(state)
    };
};

export default connect<Props, _, _, _, _, _>(mapStateToProps)(Alerts);